var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavIconOrder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_775_67186)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7754 3.75195C14.3449 3.75195 14.8844 4.0103 15.2402 4.45508L19.8642 10.2363C19.9696 10.3681 20.018 10.5367 19.997 10.7041L19.5088 14.6094C19.3913 15.5474 18.5937 16.2518 17.6484 16.252H2.35543C1.40992 16.252 0.611512 15.5475 0.494102 14.6094L0.006797 10.7041C-0.0141271 10.5367 0.0332724 10.3681 0.138633 10.2363L4.76266 4.45508C5.11848 4.0103 5.65791 3.75195 6.2275 3.75195H13.7754ZM6.2275 5.00195C6.03764 5.00195 5.85783 5.08807 5.73922 5.23633L1.92672 10.002H7.50191C7.8469 10.0022 8.12691 10.2819 8.12691 10.627C8.12717 11.6623 8.96654 12.502 10.0019 12.502C11.0371 12.5017 11.8767 11.6621 11.8769 10.627C11.8769 10.2818 12.1567 10.002 12.5019 10.002H18.0761L14.2636 5.23633C14.145 5.08807 13.9652 5.00195 13.7754 5.00195H6.2275Z",
    fill: "#212529"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_775_67186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconOrder);
export default __webpack_public_path__ + "static/media/nav-icon-order.9f55d80387509cf2055cbd3de6207d9c.svg";
export { ForwardRef as ReactComponent };